module.exports = "/_next/static/images/sea-map-e4396468a48eb156096af4288285fa69.svg";